import * as React from 'react'
import { memo } from 'react'
const SvgGift = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 15.189 16"
  >
    <path d="M1.039 16V6.913H0V3.181h4.339a1.16 1.16 0 0 1-.348-.528 2.1 2.1 0 0 1-.1-.641A1.94 1.94 0 0 1 4.478.587 1.94 1.94 0 0 1 5.903 0a1.8 1.8 0 0 1 .891.228 2.4 2.4 0 0 1 .7.593 2.3 2.3 0 0 1 .7-.6 1.8 1.8 0 0 1 .891-.225 1.94 1.94 0 0 1 1.425.587 1.94 1.94 0 0 1 .587 1.425 2 2 0 0 1-.1.635 1.23 1.23 0 0 1-.346.533h4.534v3.732H14.15v9.087ZM9.088.844a1.13 1.13 0 0 0-.832.336 1.13 1.13 0 0 0-.336.832 1.13 1.13 0 0 0 .336.832 1.13 1.13 0 0 0 .832.336 1.13 1.13 0 0 0 .832-.336 1.13 1.13 0 0 0 .336-.832 1.13 1.13 0 0 0-.336-.832 1.13 1.13 0 0 0-.833-.336ZM4.739 2.012a1.13 1.13 0 0 0 .336.832 1.13 1.13 0 0 0 .832.336 1.13 1.13 0 0 0 .832-.336 1.13 1.13 0 0 0 .336-.832 1.13 1.13 0 0 0-.336-.832 1.13 1.13 0 0 0-.832-.336 1.13 1.13 0 0 0-.832.336 1.13 1.13 0 0 0-.337.832ZM.844 4.024v2.044h6.329V4.024Zm6.329 11.132V6.913h-5.29v8.243Zm.844 0h5.29V6.913h-5.29Zm6.329-9.087V4.025H8.017v2.044Z" />
  </svg>
)
const Memo = memo(SvgGift)
export default Memo
